import { useEffect } from 'react';

import { chatStore } from '@/features/chat/chat.store';

import {
  localChatEventsBus,
  THREAD_DID_BECOME_INVISIBLE,
  THREAD_DID_BECOME_VISIBLE,
} from './chat.events';

const emitThreadVisibility = (threadId: string, visible: boolean) => {
  localChatEventsBus.emit(
    visible ? THREAD_DID_BECOME_VISIBLE : THREAD_DID_BECOME_INVISIBLE,
    { data: { threadId } }
  );
};

export const useThreadVisibility = (threadId: string) => {
  useEffect(() => {
    const handleDocumentVisibilityChange = () =>
      emitThreadVisibility(threadId, document.visibilityState !== 'hidden');
    const handleWindowBlur = () => emitThreadVisibility(threadId, false);
    const handleWindowFocus = () => emitThreadVisibility(threadId, true);

    emitThreadVisibility(threadId, document.visibilityState !== 'hidden');
    document.addEventListener(
      'visibilitychange',
      handleDocumentVisibilityChange
    );
    const unsubscribeWindowBlur = window.ipcRenderer?.on(
      'main-window-blurred',
      handleWindowBlur
    );
    const unsubscribeWindowFocus = window.ipcRenderer?.on(
      'main-window-focused',
      handleWindowFocus
    );

    return () => {
      document.removeEventListener(
        'visibilitychange',
        handleDocumentVisibilityChange
      );
      unsubscribeWindowBlur?.();
      unsubscribeWindowFocus?.();
      chatStore.clearAnimatingSlot(threadId);
      emitThreadVisibility(threadId, false);
    };
  }, [threadId]);
};
